import React, { Component } from 'react';
import { connect } from 'react-redux';
import Icon from '../../../../Icon';
import { geti18n } from '../../../../../reducers/i18n';
import { getTemporalPdfUrl, temporalPdfFetched } from '../../../../../reducers/contracts';

class ContractItem extends Component {
  getIcon(contract) {
    if (contract.get('signed')) {
      return <Icon name="download" className="contracts__check" />;
    } else {
      return <Icon name={`sign-${contract.get('contractType')}`} className="contracts__icon" />;
    }
  }

  getDescription(contractType) {
    const i18n = this.props.i18n;
    return i18n(`onboarding.contracts.${contractType}.description`);
  }

  getContractDownloadText(contractType) {
    const i18n = this.props.i18n;
    return i18n(`onboarding.contracts.${contractType}.contractNameDownload`);
  }

  getLink(contract, f) {
    const i18n = this.props.i18n;
    if (contract.get('signed')) {
      const contractName = this.getContractDownloadText(contract.get('contractType'));
      return (
        <a className="contracts__link" target="_blank" href={contract.get('contractURL')}>
          {contractName}
        </a>
      );
    } else {
      return (
        // eslint-disable-next-line
        <a
          href="#"
          className="contracts__link"
          onClick={f}
          data-contract-type={contract.get('contractType')}
          data-contract-url={contract.get('contractURL')}
        >
          {i18n(`onboarding.contracts.${contract.get('contractType')}.linkText`)}
        </a>
      );
    }
  }

  render() {
    const { contract, notSignedFucntion } = this.props;
    const description = this.getDescription(contract.get('contractType'));
    return (
      <div
        className="d-flex justify-content-center align-items-center
      text-center flex-column align-items-sm-center text-align-center flex-1"
        key={contract.get('contractURL')}
      >
        {this.getIcon(this.props.contract)}
        <div>
          <p className="mb-0">{description}</p>
          {this.getLink(contract, notSignedFucntion)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: geti18n(state),
  temporalPdfUrl: getTemporalPdfUrl(state),
  temporalPdfFetched: temporalPdfFetched(state)
});

export default connect(mapStateToProps)(ContractItem);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/Contracts/ContractItem.js